import { LOCALE_ID, NgModule } from '@angular/core';
import { CommonModule, DatePipe, registerLocaleData } from '@angular/common';
import { ImportsModule } from 'src/app/modules/shared/imports/imports.module';
import { CargueArchivosComponent } from './components/cargue-cobradores/cargue-archivo.component';
import { CargueSegurosComponent } from './components/cargue-seguro/cargue-seguro.component';
import { CargueLifeMilesComponent } from './components/cargue-lifeMiles/cargue-lifeMiles.component';
import { CargueBloqueadasComponent } from './components/cargue-cuentasBloqueadas/cargue-cuentasBloqueadas.component';
import { CargueProductosTPComponent } from './components/cargue-productosTP/cargue-productosTP.component';
import { CargueRoutingModule } from './cargue-routing.module';



@NgModule({
  declarations: [CargueArchivosComponent,
    CargueSegurosComponent,
    CargueLifeMilesComponent,
    CargueBloqueadasComponent,
    CargueProductosTPComponent,
  ],
  imports: [
    CommonModule,
    ImportsModule,
    CargueRoutingModule,
  ],
  // providers: [DatePipe, UtilsService, GenerarPdfDetalleCuotasService, GenerarPdfHistorialPagosService]
})
export class CargueModule { }